export const api= {
    GET_APP_SETTINGS: "/api/app/settings"
}